import { Users } from '@just-in-types';
import { Reducer } from 'redux';
import {
  SET_PERMISSIONS,
  SIGN_OUT,
  SUBSCRIBE_TO_USER,
  WATCH_FOR_CURRENT_USER,
} from '../actions';

const usersInitialState: IUsersState = {
  currentUser: null,
  currentUserSubscription: () => null,
  permissions: {
    businesses: [],
    ismask:false,
    role: 'user',
    sites: [],
  },
};

const usersReducer: Reducer = (
  state = usersInitialState,
  { type, payload },
) => {
  switch (type) {
    case SET_PERMISSIONS:
      return { ...state, permissions: payload };
    case SUBSCRIBE_TO_USER:
      return {
        ...state,
        currentUser: payload.user,
        currentUserSubscription: payload.subscription,
      };
    case WATCH_FOR_CURRENT_USER:
      return { ...state, currentUser: payload };

    case SIGN_OUT:
      return usersInitialState;
    default:
      return state;
  }
};

export default usersReducer;

export interface IUsersState {
  currentUser: null | Users.UserWithAccount;
  currentUserSubscription: () => void;
  permissions: Users.AccountData['permissions'];
}



// WEBPACK FOOTER //
// ./src/store/reducers/usersReducer.ts